import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BomItemType } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export function bomItemRevisionNumberSelector(bomItemPointer: BomItemPointer) {
  return function (state: RootAppState): string {
    const bomItem = bomItemSelector(state, bomItemPointer)

    if (!bomItem) {
      return ''
    }

    switch (bomItem?.type) {
      case BomItemType.partType:
      case BomItemType.partInstance:
      case BomItemType.assemblyType:
      case BomItemType.assemblyInstance:
        return bomItem.revision
      default:
        console.warn(
          'Unsupported BOM item type for revision number retrieval:',
          bomItem.type,
        )
        return ''
    }
  }
}
